import type { ChangeEventHandler } from 'react';

// Import styles
import { Label, Input, Wrapper } from './styles';

// Import components
import { CheckboxContent } from './CheckboxContent';

type Props = {
	label: string;
	checked: boolean;
	onChange: ChangeEventHandler<HTMLInputElement>;
	disabled?: boolean;
};

export const CheckboxToggler = ({ label, checked, onChange, disabled }: Props) => (
	<Wrapper>
		<Label>
			<Input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
			<CheckboxContent label={label} modifiers="invoice" />
		</Label>
	</Wrapper>
);
